import { notifyPdfLoadedSection } from '../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../PDFRenderer/PDFRendererTypes';

export const RECEIVE_DATA = 'NETWORTHDONUTCHART.RECEIVE_DATA',
  SET_TYPE = 'NETWORTHDONUTCHART.SET_TYPE';

export const receive_data = (chart_type, resp_data, clientId) => ({
  type: RECEIVE_DATA,
  chart_type,
  resp_data,
  clientId,
});

export const set_type = (chart_type, clientId) => ({
  type: SET_TYPE,
  chart_type,
  clientId,
});

export const fetch_data = (Owners, clientId) => {
  if (!clientId) return {};
  return dispatch => {
    ADV.util
      .request(
        {
          uri: 'Consumer/BalanceSheetView',
          data: {
            Owners,
            clientId,
          },
          sendStringifyJSON: true,
          showSpinner: true,
        },
        true,
      )
      .then(resp => {
        if (resp.success) {
          dispatch(receive_data(null, resp.payload.viewData, clientId));

          dispatch(notifyPdfLoadedSection(PdfSectionType.NetworthSummary));
        } else {
          dispatch(set_errors(resp.errors, clientId));
        }
      });
  };
};
